import { request } from './http';
import type { TransactionListQuery, TransactionRecord } from '@/types/transaction';
import type { PaginatedResult } from '@/types/api';

export const transactionsApi = {
  list(query: TransactionListQuery = {}) {
    return request<PaginatedResult<TransactionRecord>>({
      url: '/transactions',
      method: 'GET',
      params: query,
    });
  },
  /** 主动反查上游清算结果（运营干预入口） */
  reconcile(query: { startDate: string; endDate: string }) {
    return request<{ pulledCount: number }>({
      url: '/transactions/reconcile',
      method: 'POST',
      data: query,
    });
  },
};
